import type { GetPatientConsultRequest } from '../lib/payloads/getPatientConsult';
import type { GetPatientConsultResponse } from '../lib/responses/getPatientConsult';
import { post } from './baseUrl';
import { ApiEndpoint } from './endpoints';

export const extractPreappointmentQuestionnaireSummary = (
  preappointmentQuestionnaireSummary: string,
): string | null => {
  const summary = preappointmentQuestionnaireSummary;
  return typeof summary === 'string' && summary.trim() ? summary.trim() : null;
};

export const getPatientConsult = async (
  request: GetPatientConsultRequest,
): Promise<GetPatientConsultResponse> => {
  const response = await post(ApiEndpoint.getPatientConsult, request);

  return (response.data ?? {}) as GetPatientConsultResponse;
};
